/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'dashboard',
    title: 'Home',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: '/home',
  },

  /* --- VIRTUAL CLASROOM
  {
    id: 'classroom',
    title: 'Virtual Classroom',
    type: 'basic',
    icon: 'heroicons_outline:film',
    link: '/classroom',
  },
  */

  /**
   *  ------------------------- SUPERVISOR NAV
   */
  /*
  {
    id: 'supervisor',
    title: 'Supervisor',
    type: 'basic',
    icon: 'heroicons_outline:academic-cap',
    link: '/supervisor',
  },
*/
  {
    id: 'courses',
    title: 'Courses',
    type: 'basic',
    icon: 'heroicons_outline:cube',
    link: '/courses',
  },
  {
    id: 'supervisor-classroom',
    title: 'My Classroom',
    type: 'basic',
    icon: 'heroicons_outline:video-camera',
    link: '/supervisor/classroom',
  },
  {
    id: 'purchases',
    title: 'My purchases',
    type: 'basic',
    icon: 'heroicons_outline:shopping-bag',
    link: '/purchases',
  },
  {
    id: 'support',
    title: 'Support',
    type: 'basic',
    icon: 'heroicons_outline:chat-bubble-left-right',
    link: '/support',
  },

  /* --- supervisor
  {
    id: 'mail',
    title: 'Messages',
    type: 'basic',
    icon: 'heroicons_outline:envelope',
    link: '/supervisor',
  },
  {
    id: 'students',
    title: 'Students',
    type: 'basic',
    icon: 'heroicons_outline:user-group',
    link: '/students',
  },
  {
    id: 'rooms',
    title: 'Rooms',
    type: 'basic',
    icon: 'heroicons_outline:academic-cap',
    link: '/rooms',
  },
  */
];

export const adminNavigation: FuseNavigationItem[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: '/home',
  },
  {
    id: 'supervisor',
    title: 'Messages',
    type: 'basic',
    icon: 'heroicons_outline:envelope',
    link: '/supervisor',
  },
  {
    id: 'students',
    title: 'Students',
    type: 'basic',
    icon: 'heroicons_outline:user-group',
    link: '/students',
  },
  {
    id: 'courses',
    title: 'Courses',
    type: 'basic',
    icon: 'heroicons_outline:cube',
    link: '/courses',
  },
  {
    id: 'supervisor-classroom',
    title: 'My Classroom',
    type: 'basic',
    icon: 'heroicons_outline:video-camera',
    link: '/supervisor/classroom',
  },
  {
    id: 'course-admin',
    title: 'Course Admin',
    subtitle: 'Manage LMS content & curriculum',
    type: 'aside',
    icon: 'heroicons_outline:book-open',
    children: [
      {
        id: 'course-admin.modules',
        title: 'Modules',
        subtitle: 'Group courses into themed modules with colors and ordering',
        type: 'basic',
        icon: 'heroicons_outline:squares-2x2',
        link: '/modules-mgmt',
      },
      {
        id: 'course-admin.badges',
        title: 'Badges',
        subtitle: 'Define achievement badges that students earn on completion',
        type: 'basic',
        icon: 'heroicons_outline:star',
        link: '/badges-mgmt',
      },
      {
        id: 'course-admin.groups',
        title: 'Student Groups',
        subtitle: 'Organize students into groups and assign recurring courses',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/groups-mgmt',
      },
      {
        id: 'course-admin.cert-templates',
        title: 'Certificate Templates',
        subtitle: 'Design and preview certificate layouts for course completion',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/cert-templates',
      },
      {
        id: 'course-admin.study-plans',
        title: 'Study Plans',
        subtitle: 'Build curriculum templates that define course sequences and prerequisites',
        type: 'basic',
        icon: 'heroicons_outline:academic-cap',
        link: '/study-plans',
      },
      {
        id: 'course-admin.study-matrix',
        title: 'Study Matrix',
        subtitle: 'Company-wide overview of student progress, ratings and timelines',
        type: 'basic',
        icon: 'heroicons_outline:table-cells',
        link: '/study-matrix',
      },
      {
        id: 'course-admin.quiz-system',
        title: 'Quiz System',
        subtitle: 'Create and manage quizzes for your courses',
        type: 'basic',
        icon: 'heroicons_outline:puzzle-piece',
        link: '/quiz-system',
      },
      {
        id: 'course-admin.legacy-creation',
        title: 'Course Creation',
        subtitle: 'Open Legacy Course Editor',
        type: 'basic',
        icon: 'heroicons_outline:arrow-top-right-on-square',
        tooltip: 'Open the legacy course editor in a new tab',
        classes: {
          wrapper: 'legacy-nav-item',
          title:   'legacy-nav-title',
          icon:    'legacy-nav-icon',
        },
      },
    ],
  },
  {
    id: 'certificates',
    title: 'Certificates',
    type: 'basic',
    icon: 'heroicons_outline:trophy',
    link: '/certificates',
  },
  {
    id: 'reports',
    title: 'Reports',
    type: 'basic',
    icon: 'heroicons_outline:document-chart-bar',
    link: '/reports',
  },
  {
    id: 'sales',
    title: 'Sales',
    subtitle: 'Website sales: orders, revenue, refunds and subscriptions',
    type: 'basic',
    icon: 'heroicons_outline:banknotes',
    link: '/sales',
  },
  {
    id: 'support',
    title: 'Support',
    type: 'basic',
    icon: 'heroicons_outline:chat-bubble-left-right',
    link: '/support',
  },
  {
    id: 'settings',
    title: 'Settings',
    subtitle: 'System configuration & user management',
    type: 'aside',
    icon: 'heroicons_outline:cog-8-tooth',
    children: [
      {
        id: 'settings.companies',
        title: 'Companies',
        subtitle: 'Manage company accounts, branding and feature toggles',
        type: 'basic',
        icon: 'heroicons_outline:building-office-2',
        link: '/companies',
      },
      {
        id: 'settings.supervisors',
        title: 'Supervisors',
        subtitle: 'Add and manage supervisor accounts and their company assignments',
        type: 'basic',
        icon: 'heroicons_outline:academic-cap',
        link: '/supervisors',
      },
      {
        id: 'settings.translators',
        title: 'Translators',
        subtitle: 'Manage translator accounts for multilingual course content',
        type: 'basic',
        icon: 'heroicons_outline:language',
        link: '/translators',
      },
      {
        id: 'settings.permissions',
        title: 'Permissions',
        subtitle: 'Configure roles and fine-grained access control for all users',
        type: 'basic',
        icon: 'heroicons_outline:shield-check',
        link: '/settings/permissions',
      },
      {
        id: 'settings.vclass-admin',
        title: 'Classroom Admin',
        subtitle: 'Configure virtual classroom rooms, recordings and LiveKit settings',
        type: 'basic',
        icon: 'heroicons_outline:cog-6-tooth',
        link: '/vclass-admin',
      },
      {
        id: 'settings.system-settings',
        title: 'System Settings',
        subtitle: 'Settings for all companies and for the selected company',
        type: 'basic',
        icon: 'heroicons_outline:wrench-screwdriver',
        link: '/system-settings',
      },
      {
        id: 'settings.system',
        title: 'System',
        subtitle: 'Server diagnostics, feature flags and debug controls',
        type: 'basic',
        icon: 'heroicons_outline:server',
        link: '/system',
      },
    ],
  },
];

export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
